"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PaginationItem;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _BaseButton = _interopRequireDefault(require("../../atoms/BaseButton"));

var _styleModifiers = require("../../utils/styleModifiers");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var pageCircleDiameter = 26;

var makeSquareSizing = function makeSquareSizing(size) {
  return {
    width: (0, _rem.default)(size),
    minWidth: (0, _rem.default)(size),
    height: (0, _rem.default)(size),
    minHeight: (0, _rem.default)(size)
  };
};

var sharedStyles = (0, _styledComponents.css)(["font-size:", ";font-weight:", ";line-height:1.4;align-items:center;display:inline-flex;justify-content:center;background-color:transparent;border:1px solid transparent;outline:none;text-transform:uppercase;"], (0, _rem.default)(_typography.default.size.alias.paragraph2), _typography.default.weight.alias.default);
var PageButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "PaginationItem__PageButton",
  componentId: "sc-152aqe4-0"
})(["", ";color:", ";", ";&:active{", ";}"], sharedStyles, _colors.normalTextColor, (0, _styleModifiers.when)('active', _colors.activeColors), _colors.activeColors);

var DisabledItem = _styledComponents.default.div.withConfig({
  displayName: "PaginationItem__DisabledItem",
  componentId: "sc-152aqe4-1"
})(["", ";color:", ";"], sharedStyles, _colors.inactiveTextColor);

var Ellipsis = (0, _styledComponents.default)(DisabledItem).withConfig({
  displayName: "PaginationItem__Ellipsis",
  componentId: "sc-152aqe4-2"
})(["", ";"], makeSquareSizing(pageCircleDiameter));
var PageNumberButton = (0, _styledComponents.default)(PageButton).withConfig({
  displayName: "PaginationItem__PageNumberButton",
  componentId: "sc-152aqe4-3"
})(["border-radius:50%;", ";", ";"], makeSquareSizing(pageCircleDiameter), (0, _styleModifiers.whenNot)('active', (0, _styledComponents.css)(["&:focus:not(:active){color:", ";background-color:transparent;border-color:", ";", "}&:hover:not(:active){color:", ";background-color:", ";}"], _colors.normalTextColor, _colors.focusBorderInner, (0, _focusRingWithColor.default)(_colors.focusBorderOuter), _colors.normalTextColor, _colors.hoverFill)));
var ActivePageNumberButton = (0, _styledComponents.default)(PageNumberButton).attrs({
  as: 'div'
}).withConfig({
  displayName: "PaginationItem__ActivePageNumberButton",
  componentId: "sc-152aqe4-4"
})(["-webkit-appearance:none;"]);

var PaginationItemWrapper = _styledComponents.default.li.withConfig({
  displayName: "PaginationItem__PaginationItemWrapper",
  componentId: "sc-152aqe4-5"
})(["list-style:none;"]);

function PaginationItem(_ref) {
  var page = _ref.page,
      onClick = _ref.onClick;
  var translate = (0, _useTranslations.default)();
  var pageElement = (0, _react.useMemo)(function () {
    /*
      an item may be either...
        * a page button for the current page (page.active)
        * a page button for some other page
        * an ellipsis
     */
    if (page.ellipsis) {
      return _react.default.createElement(Ellipsis, null, "...");
    }

    if (page.active) {
      var _ariaLabel = translate(undefined, 'pagination.aria.currentPage', {
        page: "".concat(page.page)
      });

      return _react.default.createElement(ActivePageNumberButton, {
        active: true,
        "aria-current": "true",
        "aria-label": _ariaLabel
      }, page.page);
    }

    var pageClicked = function pageClicked() {
      return onClick && page ? onClick(page) : undefined;
    };

    var ariaLabel = translate(undefined, 'pagination.aria.goToPage', {
      page: "".concat(page.page)
    });
    return _react.default.createElement(PageNumberButton, {
      onClick: pageClicked,
      "aria-label": ariaLabel
    }, page.page);
  }, [page, translate, onClick]);
  return _react.default.createElement(PaginationItemWrapper, null, pageElement);
}